import { Component, Vue } from 'vue-property-decorator';

import {
  SET_TOKEN,
  SET_REFRESH_TOKEN,
  REMOVE_TOKEN,
  REMOVE_REFRESH_TOKEN,
  GET_REFRESH_TOKEN,
  SET_APIKEY,
  REMOVE_APIKEY,
} from '@/store/modules/auth/types';

@Component
export default class AuthMixin extends Vue {
  async authRegister() {
    try {
      const response = await this.$http.post('/auth/register');

      if (response.status === 201) {
        this.$store.dispatch(`auth/${SET_APIKEY}`, response.data.api_key);
        this.$store.dispatch(`auth/${SET_TOKEN}`, response.data.token);
        this.$store.dispatch(
          `auth/${SET_REFRESH_TOKEN}`,
          response.data.refresh_token
        );
        return response;
      } else {
        this.$buefy.toast.open({
          message: 'Error registring.',
          type: 'is-warning',
        });
      }
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.$buefy.toast.open({
          message: 'Already registered.',
          type: 'is-warning',
        });
      } else {
        this.$buefy.toast.open({
          message: 'Error registring.',
          type: 'is-warning',
        });
      }
      return null;
    }
  }

  async auth(linked_id?: string | null): Promise<any> {
    return new Promise((resolve, reject) => {
      this.$buefy.dialog.prompt({
        message: 'Enter your secret key for this link.',
        inputAttrs: {
          placeholder: 'Key',
          minLength: 32,
          maxlength: 32,
        },
        trapFocus: true,
        onConfirm: async (api_key: string) => {
          try {
            const response = await this.$http.post('/auth', {
              api_key,
            });

            if (response.status === 200) {
              this.$store.dispatch(`auth/${SET_TOKEN}`, response.data.token);
              this.$store.dispatch(
                `auth/${SET_REFRESH_TOKEN}`,
                response.data.refresh_token
              );

              if (linked_id) {
                try {
                  const response_video = await this.$http.get(
                    `/video/${linked_id}`
                  );

                  if (
                    response_video.status === 200 &&
                    response_video.data.authorized
                  ) {
                    resolve({ ...response, authorized: true });
                  } else {
                    this.$buefy.toast.open({
                      message: 'The key provided is not valid.',
                      type: 'is-warning',
                    });
                    resolve({ ...response, authorized: false });
                  }
                } catch (e) {
                  this.$buefy.toast.open({
                    message: 'The key provided is not valid.',
                    type: 'is-warning',
                  });
                  resolve({ ...response, authorized: false });
                }
              } else {
                resolve({ ...response, authorized: false });
              }
            } else {
              this.$buefy.toast.open({
                message: 'The key provided is not valid.',
                type: 'is-warning',
              });
            }
          } catch (e) {
            if (e.response && e.response.status === 401) {
              this.$buefy.toast.open({
                message: 'The key provided is not valid.',
                type: 'is-warning',
              });
            } else {
              this.$buefy.toast.open({
                message: 'Error authenticating.',
                type: 'is-warning',
              });
            }
          }
        },
        onCancel: () =>
          resolve({
            api_key: null,
            token: null,
            refresh_token: null,
            authorized: false,
          }),
      });
    });
  }

  async authInvalidate() {
    try {
      await this.$http.post('/auth/invalidate', {
        refresh_token: this.$store.getters[`auth/${GET_REFRESH_TOKEN}`],
      });
    } catch (e) {
      if (e.response && e.response.status !== 401) {
        this.$buefy.toast.open({
          message: 'Forcing logging out.',
          type: 'is-warning',
        });
      }
    }

    this.$store.dispatch(`auth/${REMOVE_APIKEY}`);
    this.$store.dispatch(`auth/${REMOVE_TOKEN}`);
    this.$store.dispatch(`auth/${REMOVE_REFRESH_TOKEN}`);
  }
}
